export const INVOICES = 'INVOICES'
export const INVOICE = 'INVOICE'

export default {
    INVOICES,
    INVOICE
}
